import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { APIResponse } from "../../../models/Response";
import { UserPreferences } from "../../../models/userDetails";
import { SharedService } from "../../../services/shared.service";
import {BehaviorSubject, Observable} from "rxjs";
import {
    UserDefaultImage,
    UserProfile,
    UserProfileFormControlNames,
    UserProfileFormRequestBody,
} from "../models/user-preference.model";
import { catchError } from "rxjs/operators";
import { FormBuilder, FormControl, Validators } from "@angular/forms";

@Injectable({
    providedIn: "root",
})
export class UserProfileService {
    apiServerUrl = environment.apiBaseUrl;
    userProfileImageData: BehaviorSubject<string> = new BehaviorSubject<string>('');
    userProfileImageData$ = this.userProfileImageData.asObservable();

    constructor(
        private http: HttpClient,
        private sharedService: SharedService,
        private fb: FormBuilder,
    ) {}

    getUserPreferences(): Observable<APIResponse<UserPreferences>> {
        let user_id = this.sharedService.getLoggedInUserId();
        return this.http.get<APIResponse<UserPreferences>>(
            `${this.apiServerUrl}/userPreference/getUserPreference/${user_id}`,
        );
    }

    updateUserPreferences(userPreferences: UserPreferences) {
        return this.http.post<APIResponse<UserPreferences>>(
            `${this.apiServerUrl}/userPreference/addUserPreference`,
            userPreferences,
        );
    }

    getUserProfileDetails(): Observable<APIResponse<UserProfile>> {
        let user_id = this.sharedService.getLoggedInUserId();
        return this.http
            .get<APIResponse<UserProfile>>(`${this.apiServerUrl}/user/getUserProfileDetails/${user_id}`)
            .pipe(
                catchError((error) => {
                    throw error;
                }),
            );
    }

    buildUserProfileForm() {
        return this.fb.group({
            [UserProfileFormControlNames.GIVEN_NAME]: new FormControl(""),
            [UserProfileFormControlNames.GENDER]: new FormControl("", Validators.required),
            [UserProfileFormControlNames.AGE_RANGE]: new FormControl("", Validators.required),
            [UserProfileFormControlNames.CITY]: new FormControl(""),
            [UserProfileFormControlNames.COUNTRY]: new FormControl("", Validators.required),
            [UserProfileFormControlNames.EDUCATION]: new FormControl("", Validators.required),
            [UserProfileFormControlNames.IMAGE_DATA]: new FormControl("", Validators.required),
        });
    }

    // put request to update user profile
    updateUserProfile(userProfileFormRequestBody: UserProfileFormRequestBody) {
        return this.http
            .put<APIResponse<string>>(`${this.apiServerUrl}/user/editUserProfile`, userProfileFormRequestBody)
            .pipe(
                catchError((error) => {
                    throw error;
                }),
            );
    }

    getDefaultUserImage() {
        return this.http.get<APIResponse<UserDefaultImage>>(`${this.apiServerUrl}/register/getDefaultUserImage`);
    }
    getUserProfileImage(){
        const accountIds = this.sharedService.getAllAccountIdsOfLoggedInUser(true);
        const userName = this.sharedService.getLoggedInUserName();
        return this.http.get<Blob>(`${this.apiServerUrl}/register/getUserImageByEmail/${userName}`, {
            headers: {
                accountIds: accountIds.toString(),
            },
            responseType: 'blob' as 'json'
        })
    }

    setProfilePicture(imageSrc: string): void {
        this.userProfileImageData.next(imageSrc);
    }

    convertBase64ToImage(imageSrc: string): string {
        return `data:image/png;base64,${imageSrc}`;
    }
}
